import { apiGet, apiPost } from './api';

const PAY = '/Pay';

export const getRecharges = () => apiGet(`${PAY}/getRecharges`);

export const getKits = () => apiGet(`${PAY}/getKits`);

export const getRechargeGifts = () => apiGet(`${PAY}/getGifts`);

export const mercadoPago = (body: any) => apiPost(`${PAY}/mercadopago`, body);

export const payPal = (body: any) => apiPost(`${PAY}/paypal`, body);

export const order = (body: any) => apiPost(`${PAY}/order`, body);

export const capture = (orderId: string) => apiGet(`${PAY}/capture`, { orderId });

export const orderKit = (body: any) => apiPost(`${PAY}/orderKit`, body);

export const captureKit = (orderId: string) => apiGet(`${PAY}/captureKit`, { orderId });

/* ---------------- EFI Pay (PIX) ---------------- */

export interface EfiPixOrder {
  txid: string;
  rechargeId: number;
  valor: number;
  qrCodePayload: string;          // BR Code copia-e-cola
  qrCodeImage?: string | null;    // PNG inline data URI
  expiresIn: number;              // segundos
  status: 'pending' | 'paid' | 'expired';
}

export interface EfiPixStatus {
  txid: string;
  status: 'pending' | 'paid' | 'expired' | 'canceled' | 'unknown';
  rechargeStatus: number;
}

/** Cria cobranca PIX EFI e devolve QR + copia-e-cola. `coupon` opcional (cupom de streamer). */
export const efiOrder = (body: { kit: number; coupon?: string }) =>
  apiPost<EfiPixOrder>(`${PAY}/efi/order`, body);

/** Polling de status (chamar a cada ~3s ate paid/expired). */
export const efiStatus = (txid: string) =>
  apiGet<EfiPixStatus>(`${PAY}/efi/status/${encodeURIComponent(txid)}`);

/* ---------------- Gateways disponiveis (publico) ---------------- */

export type GatewayProvider = 'EFI' | 'MP' | 'PAYPAL';

export interface PublicGateway {
  provider: GatewayProvider;
  displayName: string;
  enabled: boolean;
  ready: boolean;
  acceptCreditCard?: boolean;   // MP: "aceitar cartao" ligado no GM
}

/** Lista gateways ativos (sem secrets). Usado pra montar as opcoes de pagamento. */
export const getGateways = () => apiGet<PublicGateway[]>(`${PAY}/gateways`);
